<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-calendar-alt" class="q-mb-sm" /> {{ $t('appointment_types') }}
        </div>

        <div class="row gutter-sm">
            <div class="col-12">
                <q-field :count="256">
                    <q-input v-model="title" :float-label="$t('title')" :error="$v.title.$error" @input="$v.title.$touch" />
                </q-field>
            </div>

            <div class="col-12">
                <q-field :count="1024">
                    <q-input v-model="description" type="textarea" :error="$v.description.$error" @input="$v.description.$touch" :float-label="$t('description')" />
                </q-field>
            </div>

            <div class="col-12">
                <q-input v-model="individual_value" type="number" :float-label="$t('individual_value')" prefix="$" :decimals="2" @input="changeToDecimal" />
            </div>

            <div class="col-12">
                <q-input v-model="mininum_participants_qty" type="number" :float-label="$t('minimum_participants')" />
            </div>

            <div class="col-12" v-if="qty_presential_events > 0">
                <q-alert color="negative" icon="fas fa-exclamation" class="full-width">
                    {{ $t('this_type_of_class_is_being_used_in_events_changing_the_maximum_number_of_participants_will_change_the_maximum_number_of_participants_in_the_events_where_it_is_being_used') }}
                </q-alert>
            </div>

            <div class="col-12">
                <q-input v-model="maximum_participants_qty" type="number" :float-label="$t('maximum_participants')" />
            </div>

            <div class="col-12" v-show="false">
                <q-select v-model="area" :options="areas" :float-label="$t('areas')" :error="$v.area.$error" @input="$v.area.$touch" multiple chips />
            </div>

            <div class="col-12">
                <p class="caption">{{ $t('status') }}</p>
                <q-btn-toggle v-model="status" :toggle-color="getColorStatus" :options="status_list" />
            </div>
        </div>

        <div class="row gutter-sm justify-end q-mt-lg">
            <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="fas fa-chevron-left" @click="$router.push({ name: 'appointment_types' })" />
            </div>

            <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveData()" />
            </div>
        </div>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, minValue, maxLength } from 'vuelidate/lib/validators'
import Uploader from 'components/Uploader'

export default {
    i18nOptions: { namespaces: ['custom', 'common', 'presential', 'admin'] },

    data() {
        return {
            area: [],
            description: '',
            id: '',
            individual_value: 0,
            maximum_participants_qty: 0,
            mininum_participants_qty: 0,
            qty_presential_events: 0,
            status: 1,
            status_list: [{
                label: this.$t('active'),
                value: 1
            }, {
                label: this.$t('inactive'),
                value: 2
            }],
            title: ''
        }
    },

    components: {
        'uploader': Uploader,
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            areas: 'registration_lists/country_areas'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getColorStatus() {
            if (this.status == 1) return 'positive'
            else return 'negative'
        },

        changeToDecimal() {
            if (this.individual_value) this.individual_value = this.individual_value.toFixed(2)
        }
    },

    methods: {
        fetchData() {
            this.$q.loading.show()

            this.$axios.get(`/manager_appointments/appointment_types/${this.id}/`, this.getHeader)
            .then(response => {
                this.title = response.data.title
                this.description = response.data.description
                this.individual_value = response.data.individual_value
                this.maximum_participants_qty = response.data.maximum_participants_qty
                this.mininum_participants_qty = response.data.mininum_participants_qty
                this.status = response.data.status
                this.area = response.data.areas
                this.qty_presential_events = response.data.qty_presential_events
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        saveData() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let fd = new FormData()
                fd.append('title', this.title)
                fd.append('description', this.description)
                fd.append('individual_value', this.individual_value ? this.individual_value : 0)
                fd.append('maximum_participants_qty', this.maximum_participants_qty ? this.maximum_participants_qty : 0)
                fd.append('mininum_participants_qty', this.mininum_participants_qty ? this.mininum_participants_qty : 0)
                fd.append('status', this.status)

                this.area.forEach(area => {
                    fd.append('areas', area)
                })

                if (this.id != 0) {
                    this.$axios.put(`/manager_appointments/appointment_types/${this.id}/`, fd, this.getHeader)
                    .then(response => {
                        this.$q.notify({
                            message: this.$t('appointment_type_save_success'),
                            type: 'positive',
                            icon: 'far fa-save'
                        })

                        this.$router.push({ name: 'appointment_types' })
                    })
                    .catch(e => {
                        console.log(e)

                        this.$q.notify({
                            message: this.$t('appointment_type_save_error'),
                            type: 'negative',
                            icon: 'fas fa-ban'
                        })
                    })
                    .finally(() => {
                        this.$q.loading.hide()
                    })
                }
                else {
                    this.$axios.post(`/manager_appointments/appointment_types/`, fd, this.getHeader)
                    .then(response => {
                        this.$q.notify({
                            message: this.$t('appointment_type_save_success'),
                            type: 'positive',
                            icon: 'far fa-save'
                        })

                        this.$router.push({ name: 'appointment_types' })
                    })
                    .catch(e => {
                        console.log(e)

                        this.$q.notify({
                            message: this.$t('appointment_type_save_error'),
                            type: 'negative',
                            icon: 'fas fa-ban'
                        })
                    })
                    .finally(() => {
                        this.$q.loading.hide()
                    })
                }
            }
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        }
    },

    validations() {
        return {
            title: { required, maxLength: maxLength(256) },
            description: { maxLength: maxLength(1024) },
            area: { required },
            individual_value: {
                minValue: minValue(0)
            },
            maximum_participants_qty: {
                minValue: minValue(0)
            },
            mininum_participants_qty: {
                minValue: minValue(0)
            }
        }
    },

    created() {
        this.id = this.$route.params.id
        if (this.id != 0) this.fetchData()
        this.area = this.areas.map(e => e.value)
    }
}
</script>

<style>

</style>
